import React from 'react';
import { FullContainerModal, FullContainerScrollable, FullContainerTransform } from "../full-container";
import { ViewerControlButton, ViewerControlTooltip } from "../../controls";
import { useTranslation } from 'react-i18next';
import { nsarchives } from "../../../../i18n/namespaces";
import clsx from 'clsx';
import '@isyc-react/design/main';
import "./archive-modal.style.scss";
export const ArchiveModalContext = /*#__PURE__*/React.createContext({
  show: false,
  origin: '50% 50%'
});
export const useArchiveModalContext = () => React.useContext(ArchiveModalContext);
export const ArchiveModalProvider = props => {
  const {
    children,
    show,
    origin
  } = props;
  return /*#__PURE__*/React.createElement(ArchiveModalContext.Provider, {
    value: {
      show,
      origin
    }
  }, children);
};
export const ArchiveModalCloseButton = props => {
  const {
    onClick,
    className
  } = props;
  const {
    t
  } = useTranslation(nsarchives.common);
  return /*#__PURE__*/React.createElement(ViewerControlTooltip, {
    tooltip: t('archive.view.controls.close')
  }, /*#__PURE__*/React.createElement(ViewerControlButton, {
    onClick: () => onClick(),
    className: clsx('archive-modal-close me-0', className)
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-close"
  })));
};
export const ArchiveModalBody = props => {
  const {
    children
  } = props;
  const {
    show,
    origin
  } = useArchiveModalContext();
  return /*#__PURE__*/React.createElement(FullContainerScrollable, {
    className: "archive-modal-body-scrollable"
  }, /*#__PURE__*/React.createElement(FullContainerTransform, {
    show: show,
    origin: origin
  }, /*#__PURE__*/React.createElement("div", {
    className: "archive-modal-body"
  }, children)));
};
export const ArchiveModalHeader = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "archive-modal-header"
  }, children);
};
export const ArchiveModal = props => {
  const {
    show,
    children,
    balice,
    transform,
    size
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FullContainerModal, {
    size: size,
    show: show,
    className: "archive-modal-container",
    balice: balice,
    transformOrigin: transform
  }, origin => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArchiveModalProvider, {
    show: show,
    origin: origin
  }, children))));
};